import React from 'react';
import {useCartState} from '../components/cart';
import useQuery from './use-query';
import {useSettingsState} from '../components/settings';

const useCartStateEx = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const cartState = useCartState();
    const cs = React.useMemo(
        () =>  cartState.filter(e => e.serviceId === serviceId),
        [cartState, serviceId]
    );
    return cs;
};

export default useCartStateEx;